import { openDB } from 'idb';
import type { Cue, Settings, VideoMeta } from '../types';

const dbPromise = openDB('aurora-dub-studio', 1, { upgrade(db) { db.createObjectStore('jobs'); } });
export interface SavedJob { id: 'active'; updatedAt: number; file?: File; meta?: VideoMeta; cues: Cue[]; settings: Settings; step: string }
export async function saveJob(job: SavedJob): Promise<void> { const db = await dbPromise; await db.put('jobs', job, 'active'); }
export async function loadJob(): Promise<SavedJob | undefined> { const db = await dbPromise; return db.get('jobs', 'active') as Promise<SavedJob | undefined>; }
export async function clearJob(): Promise<void> { const db = await dbPromise; await db.delete('jobs', 'active'); }
